'use client';
import { useAuth } from '@/context/AuthContext';
import { ImagePaths, regionConfig, ROUTES } from '@/lib/utils';
import { LogOut, User } from 'lucide-react';
import { useTheme } from 'next-themes';
import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import { Button } from '../ui/button';
import { DropdownMenuItem, DropdownMenuSeparator } from '../ui/dropdown-menu';
import Container from './container';
import { DropdownMenuBase } from './dropdown-menu';

function AuthHeader() {
  const router = useRouter();
  const pathname = usePathname();
  const { signOut } = useAuth();
  const { setTheme, theme } = useTheme();
  const isDark = theme === 'dark';
  const handleThemeChange = () => {
    setTheme(isDark ? 'light' : 'dark');
  };
  const handleProfileClick = () => {
    router.push(ROUTES.PROFILE);
  };
  const handleLogout = () => {
    signOut();
  };
  const showProfileRoutes = [ROUTES.CUSTOMERDATA, ROUTES.BORROWERDATA, ROUTES.AUTHORIZEPAYMENT, ROUTES.ONBOARDING];
  const showProfile = showProfileRoutes.some((route) => pathname?.includes(route));
  const logo = regionConfig?.isUS ? ImagePaths.BANKLOGO : ImagePaths.LOGO;
  const logoClassName = regionConfig?.isUS ? 'h-10 w-40 md:w-60' : 'w-36 h-10';

  return (
    <Container className="flex justify-between items-center sticky bg-white z-20 top-0">
      <Image src={logo} alt="Logo" width={144} height={40} loading="eager" className={logoClassName} />
      <div className="flex gap-4 items-center flex-0">
        {showProfile && (
          <DropdownMenuBase
            trigger={
              <Button className="bg-gray-100 rounded-full size-10 cursor-pointer" variant="link" size="icon">
                <User className="size-6" />
              </Button>
            }
            align="end"
          >
            <DropdownMenuItem onClick={handleProfileClick} className="py-1 px-2 cursor-pointer">
              Profile
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild variant="destructive" className="py-1 px-2 cursor-pointer">
              <button className="text-brand-red w-full flex items-center gap-1" onClick={handleLogout}>
                <LogOut size={16} /> Logout
              </button>
            </DropdownMenuItem>
          </DropdownMenuBase>
        )}
        {/* <Button variant="outline" type="button" size="icon" onClick={handleThemeChange}>
          {isDark ? <Sun /> : <Moon />}
        </Button> */}
      </div>
    </Container>
  );
}

export default AuthHeader;
